import { useEffect, useRef } from 'react'
import cc from 'classcat'

import icons from './icon-picker-icons.json'

type Props = Readonly<{
  icon: string
  setIcon: (icon: string) => void
  className?: string
}>

export default function IconPicker({ icon, setIcon, className }: Props) {
  const activeIconElement = useRef<HTMLButtonElement | null>(undefined)

  useEffect(() => {
    activeIconElement.current?.scrollIntoView({ block: 'nearest' })
  }, [])

  return (
    <scroll-shadow>
      <div className={cc(['ep-icon-picker-wrapper', className])}>
        {icons.map((category, index) => (
          <div key={index} className="ep-icon-picker-category">
            {category.map((name) => (
              <div key={name} className="body">
                {/* "body" class so that the theme's icon styles apply */}
                <button
                  type="button"
                  data-testid={`icon-picker-${name}-icon`}
                  className={cc([
                    `ep-${name}-icon`,
                    {
                      selected: name === icon,
                    },
                  ])}
                  ref={(node) => {
                    if (name === icon) {
                      activeIconElement.current = node
                    }
                  }}
                  onClick={() => setIcon(name)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </scroll-shadow>
  )
}
